var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
class IconCloudLockLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconCloudLock",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      children: _path || (_path = _jsx("path", {
        d: "M1027.72 849.165c124.687 0 225.882 101.308 225.882 225.882v112.941h112.941v395.294c0 93.403-75.896 169.412-169.412 169.412H858.308c-93.403 0-169.412-76.01-169.412-169.412v-395.294h112.941v-112.94c0-124.575 101.308-225.883 225.883-225.883Zm225.882 451.764H801.837v282.353c0 31.172 25.412 56.47 56.47 56.47h338.824c31.172 0 56.47-25.298 56.47-56.47V1300.93ZM960 167c221.816 0 408.847 143.661 478.08 342.212 10.165-.678 19.99-3.388 30.155-3.388 249.036 0 451.765 202.616 451.765 451.764s-202.73 451.765-451.765 451.765v-112.941c186.805 0 338.824-152.02 338.824-338.824s-152.019-338.823-338.824-338.823c-1.92 0-3.727.564-5.647.677 2.146 18.523 5.647 36.706 5.647 55.793 0 44.386-5.76 88.32-16.94 130.786l-109.215-29.139c8.81-32.866 13.214-67.087 13.214-101.647 0-217.976-177.318-395.294-395.294-395.294-212.442 0-385.13 168.96-393.713 379.257 38.287 18.522 74.428 41.9 105.6 72.395l-78.946 80.753c-53.195-52.066-123.332-80.64-197.647-80.64-155.633 0-282.353 126.72-282.353 282.353s126.72 282.353 282.353 282.353h169.412v112.94H395.294C177.318 1409.353 0 1232.036 0 1014.06c0-217.977 177.318-395.294 395.294-395.294 20.894 0 41.337 2.71 61.553 5.986C482.597 368.487 697.073 167 960 167Zm67.72 795.106c-62.231 0-112.942 50.71-112.942 112.941v112.941h225.883v-112.94c0-62.232-50.598-112.942-112.941-112.942Z",
        fillRule: "evenodd"
      }))
    });
  }
}
IconCloudLockLine.glyphName = 'cloud-lock';
IconCloudLockLine.variant = 'Line';
IconCloudLockLine.displayName = 'IconCloudLockLine';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconCloudLockLine.propTypes = {
  ...SVGIcon.propTypes
};
IconCloudLockLine.allowedProps = [...SVGIcon.allowedProps];
export default IconCloudLockLine;
export { IconCloudLockLine };